var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Link } from 'syf-component-library/ui/atoms';
import styled from 'styled-components';
import { colors } from 'syf-component-library/defaultTheme';
import query from 'syf-component-library/const/mediaQueries';
var OnlineChatLink = styled(Link)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  margin-left: 0px;\n  padding: 0px;\n  display: inline;\n  font-weight: 900;\n  cursor: pointer;\n  @media ", " {\n    margin-left: 0px;\n  }\n"], ["\n  color: ", ";\n  margin-left: 0px;\n  padding: 0px;\n  display: inline;\n  font-weight: 900;\n  cursor: pointer;\n  @media ", " {\n    margin-left: 0px;\n  }\n"])), colors.cyanBlue, query.lessThanMedium);
export default OnlineChatLink;
var templateObject_1;
//# sourceMappingURL=index.js.map